import { render } from "./EditarEquipo.vue?vue&type=template&id=0c07e72c&scoped=true"
import script from "./EditarEquipo.vue?vue&type=script&lang=js"
export * from "./EditarEquipo.vue?vue&type=script&lang=js"

import "./EditarEquipo.vue?vue&type=style&index=0&id=0c07e72c&scoped=true&lang=css"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c07e72c"]])

export default __exports__